import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ 'game', 'gameIds' ]

  connect() {
    // console.log("Hello, Debug Controller here!", this.element);
  }

  toggleAllGames(event) {
    this.gameTargets.forEach(game => {
      game.checked = event.target.checked;
    });
  }

  deleteGames(event) {
    const game_ids = this.gameTargets.filter(game => game.checked).map(game => game.value);

    this.gameIdsTarget.value = JSON.stringify(game_ids);
  }



}
